<template>
  <mavon-editor
    :external-link="externalLink"
    @change="changeCon"
    v-model="context"
    :toolbars="toolbars"
  />
</template>

<script>
import { mavonEditor } from "mavon-editor";
import "mavon-editor/dist/css/index.css";
export default {
  name: "mavon",
  components: {
    mavonEditor,
  },
  props: {
    text: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      externalLink: {
        markdown_css: () => "/md/markdown/github-markdown.min.css",
        hljs_js: () => "/md/highlightjs/highlight.min.js",
        hljs_css: (css) => "/md/highlightjs/styles/" + css + ".min.css",
        hljs_lang: (lang) => "/md/highlightjs/languages/" + lang + ".min.js",
        katex_css: () => "/md/katex/katex.min.css",
        katex_js: () => "/md/katex/katex.min.js",
      },
      context: " ", //输入的数据
      toolbars: {
        bold: true, // 粗体
        italic: true, // 斜体
        header: true, // 标题
        underline: true, // 下划线
        mark: true, // 标记
        superscript: true, // 上角标
        quote: true, // 引用
        ol: true, // 有序列表
        // link: true, // 链接
        // imagelink: true, // 图片链接
        help: true, // 帮助
        code: true, // code
        subfield: true, // 是否需要分栏
        fullscreen: true, // 全屏编辑
        readmodel: true, // 沉浸式阅读
        undo: true, // 上一步
        trash: true, // 清空
        save: true, // 保存（触发events中的save事件）
        navigation: true, // 导航目录
      },
    };
  },
  methods: {
    changeCon(val) {
      this.$emit("change", val);
    },
  },
  created() {
    let set = setTimeout(() => {
      this.context = this.text;
      clearTimeout(set);
    }, 0);
  },
};
</script>

<style lang="less">
.markdown-wrapper {
  .editor-toolbar.fullscreen {
    z-index: 9999;
  }
  .CodeMirror-fullscreen {
    z-index: 9999;
  }
  .CodeMirror-fullscreen ~ .editor-preview-side {
    z-index: 9999;
  }
}
</style>
